'use client';

import { createContext, useContext } from 'react';
import type { RosSignalR } from 'lib/roslibjs';

export type GetDeviceRos = (deviceName: string) => RosSignalR;

export const FleetRosBridgeContext = createContext<GetDeviceRos | null>(null);

export function useFleetRosBridge(): GetDeviceRos {
  const getDeviceRos = useContext(FleetRosBridgeContext);
  if (!getDeviceRos) throw new Error('useFleetRosBridge must be used within FleetRosBridgeProvider');
  return getDeviceRos;
}
